'use strict';

/* eslint-disable no-underscore-dangle */

var entry = {
  /**
     * options
     * @type {Object}
     */
  options: {
    isHttps: typeof location !== 'undefined' && location && !!location.href.match(/^https/),
    httpsProxySvr: '//proxy.now.qq.com/tx_tls_gate=',
    httpsProxy: {
      // 'report.huatuo.qq.com': true,
      'isdspeed.qq.com': true,
      'c.isdspeed.qq.com': true
    }
  },

  /**
     * config
     * @param {Object} options
     */
  cfg: function cfg(options) {
    Object.keys(options).forEach(function (k) {
      if (Object.prototype.hasOwnProperty.call(options, k)) {
        entry.options[k] = options[k];
      }
    });
  },


  /**
     * 上报 url过长时自动使用post方式
     * @param {String} url
     * @param {Object} p
     */
  send: function send(_u, _p) {
    var url = _u;
    var p = _p;
    var domain = url.match(/\/\/([^\/]+)/) && RegExp.$1 || '';
    var options = entry.options;

    p = p || {};
    p._ = Math.random();
    // 去除协议头
    url = url.replace(/^https?:/, '');
    if (options.isHttps && options.httpsProxy[domain]) {
      url = options.httpsProxySvr + url.replace(/^(https?:)?\/\//, '');
    }

    var _url = url + (url.match(/\?/) ? '&' : '?') + entry.param(p);

    // 统一上报
    if (window.__UniRep) {
      window.__UniRep.push(_url);
    } else {
      // url过长时使用post发送请求
      if (_url.length > 3000) {
        entry._postSend(url, p);
      } else {
        var image = new Image();
        image.src = _url;
      }
    }
  },
  encodeFormData: function encodeFormData(data) {
    if (!data) return '';
    var pairs = [];
    Object.keys(data).forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        var value = data[key].toString();
        pairs.push(key + '=' + value);
      }
    });
    return pairs.join('&');
  },


  /**
     * post上报
     * @param {String} url
     * @param {Object} p
     */
  _postSend: function _postSend(url, p) {
    // RN下，使用XHR进行上报
    if (location && location.href.indexOf('_md=rn') > -1) {
      if (typeof XMLHttpRequest !== 'undefined') {
        var xhr = new XMLHttpRequest();
        xhr.open('post', url);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset-UTF-8');
        xhr.send(this.encodeFormData(p));
      }
      return;
    }
    p = p || {};
    var _document = document,
        body = _document.body;

    var ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    ifr.src = 'about:blank';
    ifr.name = 'tmp' + Math.random().toString().substr(2, 10);
    body.appendChild(ifr);

    var fm = document.createElement('form');
    fm.method = 'post';
    fm.action = url;
    fm.target = ifr.name;
    fm.enctype = 'application/x-www-form-urlencoded';
    fm.style.display = 'none';

    Object.keys(p).forEach(function (k) {
      if (Object.prototype.hasOwnProperty.call(p, k)) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = k;
        input.value = p[k];
        fm.appendChild(input);
      }
    });

    body.appendChild(fm);

    setTimeout(function () {
      fm.submit();
    }, 50);

    setTimeout(function () {
      body.removeChild(fm);
      body.removeChild(ifr);
    }, 3000);
  },


  /**
     * $.param()
     * @param {Object} p
     * @return {String}
     */
  param: function param(p) {
    var str = [];
    Object.keys(p).forEach(function (k) {
      if (Object.prototype.hasOwnProperty.call(p, k)) {
        var v = typeof p[k] === 'undefined' ? '' : p[k];
        str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });

    return str.join('&');
  },


  /**
     * 拼接url
     * @param {String} url
     * @param {Object} p
     * @return {String}
     */
  getUrl: function getUrl(url, p) {
    var pstr = entry.param(p || {});
    return url + (pstr ? (url.match(/\?/) ? '&' : '?') + pstr : '');
  }
};

module.exports = entry;